import React from "react";
import BackgroundLayer from "./BackgroundLayer";
import TabBar from "./TabBar";

/**
 * Full-screen shell: fixed background, scrollable content, optional bottom tab bar.
 */
export default function Shell({ section = "home", tabbar = true, children, padBottom = true }) {
  return (
    <div className="min-h-screen flex flex-col">
      <BackgroundLayer section={section} />
      <main
        key={section}
        className="flex-1 w-full max-w-2xl mx-auto px-4 sm:px-6 screen-enter"
        style={{ paddingTop: 20, paddingBottom: tabbar && padBottom ? 96 : 16 }}
      >
        {children}
      </main>
      {tabbar && <TabBar />}
    </div>
  );
}
